<template>
  <div class="shop-wrap ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-4 order-xl-1 order-2">
          <SidebarWidget />
        </div>
        <div class="col-xl-8 order-xl-2 order-1">
          <div class="row mb-30">
            <div class="col-lg-8 col-md-6">
              <div class="d-md-flex align-items-center">
                <form action="#" class="search-form position-relative">
                  <input type="search" placeholder="Search Here" />
                  <button
                    type="submit"
                    class="position-absolute border-0 d-flex flex-column align-items-center justify-content-center"
                  >
                    <i class="ri-search-line"></i>
                  </button>
                </form>
                <p class="search-result mb-0 ms-3">
                  Showing 1–9 of 130 results
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 text-md-end">
              <select class="filter-cat">
                <option value="0">Default Shorting</option>
                <option value="0">Short by latest</option>
                <option value="1">Short by Popular</option>
                <option value="2">Low to High</option>
              </select>
            </div>
          </div>

          <div class="shop-card-wrap style-two gx-0">
            <div
              class="shop-card position-relative"
              v-for="product in products"
              :key="product.id"
            >
              <div
                class="shop-promo style-one lh-1 position-absolute text-white"
              >
                {{ product.state }}
              </div>
              <router-link class="add-to-cart position-absolute" to="/cart">
                <img src="../../assets/img/icons/cart.svg" alt="Image" />
              </router-link>
              <div class="shop-img overflow-hidden">
                <img
                  :src="product.image"
                  alt="Image"
                  class="d-block mx-auto transition"
                />
              </div>
              <div
                class="shop-info d-flex align-items-center justify-content-between"
              >
                <div>
                  <ul class="ratings list-style">
                    <li><i class="ri-star-s-fill"></i></li>
                    <li><i class="ri-star-s-fill"></i></li>
                    <li><i class="ri-star-s-fill"></i></li>
                    <li><i class="ri-star-s-fill"></i></li>
                    <li><i class="ri-star-s-fill"></i></li>
                  </ul>
                  <h3 class="fs-20">
                    <router-link to="/product-details">
                      {{ product.title }}
                    </router-link>
                  </h3>
                  <router-link to="/shop-left-sidebar" class="shop-cat">
                    {{ product.category }}
                  </router-link>
                </div>
                <span class="fs-20 fw-bold f-secondary text_primary">
                  ${{ product.price }}
                </span>
              </div>
            </div>
          </div>

          <ul class="page-nav list-style text-center mt-5">
            <li>
              <a
                class="d-flex flex-column justify-content-center align-items-center rounded-circle"
                href="#"
              >
                <i class="ri-arrow-left-s-line"></i>
              </a>
            </li>
            <li>
              <a
                class="d-flex flex-column justify-content-center align-items-center rounded-circle active"
                href="#"
              >
                01
              </a>
            </li>
            <li>
              <a
                class="d-flex flex-column justify-content-center align-items-center rounded-circle"
                href="#"
              >
                02
              </a>
            </li>
            <li>
              <a
                class="d-flex flex-column justify-content-center align-items-center rounded-circle"
                href="#"
              >
                03
              </a>
            </li>
            <li>
              <a
                class="d-flex flex-column justify-content-center align-items-center rounded-circle"
                href="#"
              >
                <i class="ri-arrow-right-s-line"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SidebarWidget from "./SidebarWidget.vue";

export default defineComponent({
  name: "ShopLeftSidebar",
  components: {
    SidebarWidget,
  },
  data() {
    return {
      products: [
        {
          id: 1,
          state: "Sale",
          image: require("../../assets/img/shop/shop-1.webp"),
          title: "Thin can Mockup",
          category: "BRANDING",
          price: "67",
        },
        {
          id: 2,
          state: "Sale",
          image: require("../../assets/img/shop/shop-2.webp"),
          title: "Mac Coffee",
          category: "Drink",
          price: "45",
        },
        {
          id: 3,
          state: "",
          image: require("../../assets/img/shop/shop-3.webp"),
          title: "Pure Honey",
          category: "Food",
          price: "120",
        },
        {
          id: 4,
          state: "New",
          image: require("../../assets/img/shop/shop-4.webp"),
          title: "Thick Sweater Bottle",
          category: "BRANDING",
          price: "34",
        },
        {
          id: 5,
          state: "",
          image: require("../../assets/img/shop/shop-5.webp"),
          title: "Cat Food",
          category: "Food",
          price: "37",
        },
        {
          id: 6,
          state: "Hot",
          image: require("../../assets/img/shop/shop-6.webp"),
          title: "Organic Herbs Honey",
          category: "Drink",
          price: "56",
        },
        {
          id: 7,
          state: "Sale",
          image: require("../../assets/img/shop/shop-7.webp"),
          title: "Kitten Cake",
          category: "Pet Food",
          price: "45",
        },
        {
          id: 8,
          state: "",
          image: require("../../assets/img/shop/shop-8.webp"),
          title: "Ramen Noodles",
          category: "Food",
          price: "87",
        },
      ],
    };
  },
});
</script>